import gql from 'graphql-tag';
import { STOCK_TRANSFER_FRAGMENT } from '../fragments/stockTransfer';

export const GET_STOCK_TRANSFERS_QUERY = gql`
    query GET_STOCK_TRANSFERS(
        $offset: Int
        $limit: Int
        $sortBy: String
        $sortOrder: String
        $filters: StockTransfersFilterInput
    ) {
        stockTransfers(offset: $offset, limit: $limit, sortBy: $sortBy, sortOrder: $sortOrder, filters: $filters) {
            hasMore
            stockTransfers {
                _id
                transferDate
                state
                destinationColumn {
                    fullname
                }
                originColumn {
                    fullname
                }
                quantityOfProducts
                numberOfRefs
                reassortmentFlow
                isForReassortment
                shouldUpdateStockImmediately
                createdAt
                updatedAt
            }
        }
    }
`;

export const GET_RETURNED_STOCK_TRANSFERS_QUERY = gql`
    query GET_RETURNED_STOCK_TRANSFERS($transferDate: String!) {
        returnedStockTransfers(transferDate: $transferDate) {
            _id
            state
            originColumn {
                fullname
            }
            products {
                productId
                fullname
                originStockAvailable
                destinationStockAvailable
                quantity
            }
            updatedAt
        }
    }
`;

export const GET_STOCK_TRANSFER_QUERY = gql`
    query GET_STOCK_TRANSFER($stockTransferId: ID!) {
        stockTransfer(stockTransferId: $stockTransferId) {
            ...StockTransferFragment
        }
    }
    ${STOCK_TRANSFER_FRAGMENT}
`;
